<app-create-tabs
  [steps]="bundleSteps"
  [activeStep]="activeStep()"
  [completedSteps]="completedSteps()"
  [disabledSteps]="disabledSteps()"
  (stepChange)="handleStepChange($event)"></app-create-tabs>

<div class="mt-6">
  @switch (activeStep()) {
    @case (1) {
      <app-create-bundle-info-component (onSuccess)="onBundleCreated($event)" />
    }
    @case (2) {
      <app-create-bundle-included-component />
    }
  }
</div>
